import {
    CV_LIST,
    CV_DETAIL,
    UNAUTHORIZE,
    OPEN_MODEL
} from '../actions/ActionType'

const INITIAL_STATE = {
    open_modal: false,
    list: [],
    detail: {},
    unauthorize: false
}

export default (state=INITIAL_STATE, action ) => {
   
    switch(action.type) {

        case OPEN_MODEL: 
            return {
                ...state, open_modal: action.payload
            }

        case CV_LIST:
            return { ...state, list: action.payload }

        case CV_DETAIL:
            return { ...state, detail: action.payload }

        case UNAUTHORIZE:
            return {...state, unauthorize: action.payload}

        default:
            return state
    }

}